
import type { PropType } from 'vue'

import type {
    DispatcherWorkplaceDataEntity,
    DispatcherWorkplaceDelivery,
    DispatcherWorkplaceRecordWaitListStatus,
    DispatcherWorkplaceTake
} from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent, computed } from 'vue'

import DwBadge from '@/modules/DispatcherWorkplaceModule/ui/DwBadge/index.vue'
import DwCheckbox from '@/modules/DispatcherWorkplaceModule/ui/DwCheckbox/index.vue'
import DwWaitListStatus from '@/modules/DispatcherWorkplaceModule/components/DwWaitListStatus/index.vue'
import DwActionSequenceIcon from '@/modules/DispatcherWorkplaceModule/components/DwActionSequenceIcon/index.vue'

import {
    DELIVERY_MARKER_COLOR,
    UNDELIVERED_DELIVERY_MARKER_COLOR,
    TAKE_MARKER_COLOR,
    UNASSIGNED_TAKE_MARKER_COLOR
} from '@/modules/DispatcherWorkplaceModule/constants'

export default defineComponent({
    components: {
        DwBadge,
        DwCheckbox,
        DwWaitListStatus,
        DwActionSequenceIcon
    },
    props: {
        entity: {
            type: Object as PropType<DispatcherWorkplaceDataEntity>,
            required: true
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        selectedUnassignedTakes: {
            type: Array as PropType<Array<number>>,
            default: () => []
        },
        selectedFeatureId: {
            type: String as PropType<string | null>,
            default: null
        },
        isCourierItem: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click', 'toggle-unassigned-take'],
    setup(props, { emit }) {
        const onClick = () => {
            emit('click', { ...props.entity })
        }

        const onToggleUnassignedTake = (take_id: number) => {
            emit('toggle-unassigned-take', take_id)
        }

        const isEntitySelected = computed(() => {
            if (props.selectedFeatureId) {
                if (props.entity.type === 1) {
                    return (props.entity as DispatcherWorkplaceTake).orderNumber === props.selectedFeatureId
                }

                if (props.entity.type === 2) {
                    return (props.entity as DispatcherWorkplaceDelivery).invoiceNumber === props.selectedFeatureId
                }
            }

            return false
        })

        const isEntityCompleted = computed(() => {
            if (props.entity.type === 1) {
                const takeEntity = props.entity as DispatcherWorkplaceTake
                return takeEntity.state === 1 || takeEntity.statusId === 3
            }

            if (props.entity.type === 2) {
                const deliveryEntity = props.entity as DispatcherWorkplaceDelivery
                return deliveryEntity.state === 1
            }

            return false
        })

        const computedColor = computed(() => {
            if (props.entity.type === 1) {
                if ((props.entity as DispatcherWorkplaceTake).notAssigned) {
                    return UNASSIGNED_TAKE_MARKER_COLOR
                }
                
                return TAKE_MARKER_COLOR
            }

            if (props.entity.type === 2) {
                if ((props.entity as DispatcherWorkplaceDelivery).notDelivered) {
                    return UNDELIVERED_DELIVERY_MARKER_COLOR
                }

                return DELIVERY_MARKER_COLOR
            }

            return 'black'
        })

        return {
            onClick,
            onToggleUnassignedTake,
            isEntitySelected,
            isEntityCompleted,
            computedColor,
        }
    }
})
